'use client';

import { FC, useMemo, useState } from 'react';

import { PlayIcon } from 'components/icons';
import { Dialog, DialogContent } from 'components/ui/dialog';

import { extractVideoId } from 'utils/video';

export const VideoModal: FC<{ videoUrl: string;  }> = ({ videoUrl}) => {
  const [isOpen, setOpen] = useState(false);

  const thumbLink = useMemo(() => `http://img.youtube.com/vi/${extractVideoId(videoUrl)}/hqdefault.jpg`, [videoUrl]);
  const videoIframeUrl = useMemo(() => `https://www.youtube.com/embed/${extractVideoId(videoUrl)}`, [videoUrl]);

  return (
    <>
      <div className="relative p-5 border border-white-alpha-30 bg-white-alpha-10 rounded-xl overflow-hidden md:w-[107px] md:h-[107px] lg:p-2 md:mx-auto aspect-square">
        <div
          className="absolute top-0 left-0 h-full w-full z-50 flex items-center justify-center duration-700 hover:scale-150 cursor-pointer"
          onClick={() => setOpen(true)}
        >
          <div
            className="h-[35px] w-[35px] bg-white-alpha-12 border border-white-alpha-20 rounded-full flex items-center justify-center backdrop-blur-[2px]">
            <div
              className="h-[26px] w-[26px] bg-white-alpha-20 border border-white-alpha-20 rounded-full flex items-center justify-center backdrop-blur-[2px]">
              <PlayIcon />
            </div>
          </div>
        </div>
        <img className="w-full md:h-full sm:aspect-auto aspect-square" src={thumbLink} />
      </div>
      {isOpen && (
        <Dialog
          open
          onOpenChange={() => setOpen(false)}
        >
          <DialogContent className="min-w-[626px] md:min-w-0">
            <div className="pt-3">
              <iframe width="100%" height="315" src={videoIframeUrl}
                      title="YouTube video player" frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen></iframe>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  )
}
